<template>
  <container
    :subHeaderTitle="serviceType"
    subHeaderText="휴대폰으로 전송된 인증번호를 입력해주세요."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>인증번호</p>
              <div class="d-flex">
                <v-text-field
                  ref="certNum"
                  label="인증번호 입력"
                  mask="########"
                  :rules="rules.certNumRules"
                  v-model="certNum"
                  :suffix="countdown"
                  required
                  solo
                />
                <v-btn large depressed class="ml-2 resend" @click.stop="sendSmsCert"
                :data-ga-category="gaEvent.category.support.safeguard.lgIdVerifyCert.name" :data-ga-label="gaEvent.category.support.safeguard.lgIdVerifyCert.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >재전송</v-btn>
              </div>
              <div class="pl-5 mt-2 mb-12">
                <ul>
                  <li>인증번호는 3분 이내에 입력하셔야 합니다.</li>
                  <li>인증시간이 초과하면 재전송하여 인증하시기 바랍니다.</li>
                </ul>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                :data-ga-category="gaEvent.category.support.safeguard.lgIdVerifyCert.name" :data-ga-label="gaEvent.category.support.safeguard.lgIdVerifyCert.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >확인</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.safeguard.lgIdVerifyCert.name" :data-ga-label="gaEvent.category.support.safeguard.lgIdVerifyCert.label3" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 오류 팝업 -->
    <v-dialog v-model="errDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4 v-html="errDialogText"></h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="errDialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 미성년자 체크 팝업 -->
    <v-dialog v-model="adtDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4 v-html="adtDialogText"></h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goNext()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- nice 인증 실패시 팝업 -->
    <v-dialog v-model="niceErrDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>본인확인에 실패하였습니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 인증번호 인증 실패시 팝업 -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증번호가 일치하지 않습니다.<br />전송된 인증번호를 확인해보세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="dialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 처리 프로그레스 -->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 처리결과 다이얼로그  -->
    <v-dialog v-model="resultDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적으로 처리되지 않았습니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goNext()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- router Param 없을때 -->
    <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적인 접근이 아닙니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 시간제한 지났을때 -->
    <v-dialog v-model="countDownOverDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증시간이 초과했습니다.<br />인증번호를 재전송하여 인증해주세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="countDownOverDialog = !countDownOverDialog">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeGuardIdVerifyCert from "@/views/csCenter/PassSafeGuardIdVerifyCert.vue";
import { CONSTANS } from "@/const/index.js";
import { generateSHA256Hash, formater } from "@/mixins/index.js";

export default {
  mixins: [PassSafeGuardIdVerifyCert, generateSHA256Hash, formater],
  name: "PassSafeGuardIdVerifyCert",
  components: {
    Container
  },
  computed: {
    serviceType() {
      return this.type === "contract" ? "세이프가드·금융사기방지<br /><b>가입하기</b>" : "세이프가드·금융사기방지<br /><b>해지하기</b>";
    }
  },
  methods: {
    submit(e) {
      this.gaTracking(e);
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      this.progressDialog = true;

      if (this.countdown === "0:00") {
        this.progressDialog = false;
        this.countDownOverDialog = true;
        return false;
      }

      const params = {
        type: this.type,
        teleCoCd: this.teleCoCd,
        cellTelNo: this.cellTelNo,
        birth: this.birth,
        genCd: this.genCd,
        name: this.name,
        certNum: this.certNum,
        prdtNo: this.prdtNo,
        couplingKey: this.couplingKey,
        chanCd: "F100", // 홈페이지 chanCd
        mvnoYn: this.mvnoYn,
      };

      // 가입 / 해지
      this.axios
        .post("/rest/chanCust", {
          ...params
        })
        .then((result) => {
          this.progressDialog = false;
          if (result.data.resultCd === "S0000") {
            const date = this.formatDate(new Date(), "YYYYMMDDHHmmssSSS");

            if (this.type === "contract") {
              this.$gtag.purchase({
                transaction_id: this.generateSHA256Hash(this.cellTelNo) + date,
                value: CONSTANS.SG_PRICE,
                currency: "KRW",
                items: [
                  {
                    item_id: CONSTANS.SG_CHAN_CD,
                    item_name: CONSTANS.SG_CHAN_CD,
                    item_variant: CONSTANS.TELE_CO_CD_NM[this.teleCoCd]
                  }
                ]
              });
            }
            this.$router.push({
              name: "PassSafeGuardResult",
              params: { type: this.type, result: "SUCCESS" }
            });
          } else if (result.data.resultCd === "E9990") {
            this.dialog = true;
          } else if (result.data.resultCd === "F3714") {
            this.errDialogText =
              "PASS 금융사기방지 (WEB)서비스는<br/> 1일 이후 재가입 가능한 서비스 입니다.<br/>즉시 가입을 원하시는 경우 <br/> PASS by U+를 설치하시어 <br/>PASS금융사기방지 서비스를 <br/>가입해 주세요.";
            this.errDialog = true;
          } else if (result.data.resultCd === "E4202" || result.data.resultCd === "E4445" || result.data.resultCd === "E4446") {
            this.errDialogText = "기존 유료 가입자입니다.<br/>PASS 앱에서 확인하세요";
            this.errDialog = true;
          } else if (result.data.resultCd === 'E8000') {
            this.$router.push({ name: "PassSafeGuardResult", params: { type: this.type, result: "LIMIT", user: {...params} } });
          } else {
            this.goNext();
          }
        })
        .catch((result) => {
          this.progressDialog = false;
          this.goNext();
        });
    },
    goNext() {
      this.resultDialog = false;
      this.$router.push({ name: "PassSafeGuardResult", params: { type: this.type, result: "FAIL" } });
    },
    goReturn() {
      this.$router.push({ name: "Support" });
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.go(-1);
    }

  }
};
</script>
